export const PDF = 0
export const IMAGES = 1